<template>
  <div class="out-of-stock">
    <span :data-test="'outOfStockSpan'+position" :id="'outOfStockSpan-id'+position">
      <!-- <div class="icon icon--ei-exclamation icon--s">
        <svg class="icon__cnt">
          <use xlink:href="#ei-exclamation-icon"></use>
        </svg>
        <div></div>
      </div> -->
      Out Of Stock
    </span>
  </div>
</template>

<script>
export default {
	props: {
		position: {
			type: Number,
			default: 0
		}
	}
}
</script>
